import axios from 'axios';
import base64 from 'base-64';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import {
    Binance_addCoinS, Binance_addCoinF, OKX_addCoinS, OKX_addCoinF, change_Binance_position, change_OKX_position, check_OKX_Instruments, addCoin_OKX_S_Favorite, addCoin_OKX_F_Favorite,
    addCoin_Binance_S_Favorite, addCoin_Binance_F_Favorite, changeKYC, change_Binance_wallet_spot, change_Binance_wallet_futures, change_OKX_wallet, change_Binance_openorder_futures, change_OKX_wallet_availBal, change_OKX_wallet_usdt,
    change_Binance_liquidation, change_OKX_liquidation, change_Binance_ListenKey, check_Error,
    checkOKX_timestamp
} from './store';
import { useLocation } from 'react-router-dom';
import isEqual from 'lodash/isEqual';

const Binance_urlS = 'https://api.binance.com/api/v3/ticker/24hr';
const Binance_urlF = 'https://fapi.binance.com/fapi/v1/ticker/24hr';
const OKX_urlS = 'https://www.okx.com/api/v5/market/tickers?instType=SPOT';
const OKX_urlF = 'https://www.okx.com/api/v5/market/tickers?instType=SWAP';

let cnt_login = 0
let cnt = 0
let preArr = []
let bn_name = []
let okx_name = []

let version = "1.240420.02"

function Api() {
    let dispatch = useDispatch();
    let login = useSelector((state) => { return state.login.value });
    let SelectType = useSelector((state) => { return state.SelectType.value })
    let API_Address = useSelector((state) => { return state.API_Address.value })

    let location = useLocation();

    const [instrumentsData, setInstrumentData] = useState([])
    const [loca, setLoca] = useState("main")
    const [listenkey_futures, setListenkey_futures] = useState("")
    const [listenkey_spot, setListenkey_spot] = useState("")

    useEffect(() => {
        if (location.pathname == '/') setLoca("main")
        else if (location.pathname.includes("market")) setLoca("market")
        else if (location.pathname.includes("spot")) setLoca("spot")
        else if (location.pathname.includes("futures")) setLoca("futures")
        else if (location.pathname.includes("wallet")) setLoca("wallet")
        else if (location.pathname.includes("dashboard")) setLoca("dashboard")
        else setLoca("else")
        CheckVersion()
    }, [location])

    // let OKX_timestamp = useSelector((state) => { return state.OKX_timestamp.value });
    // console.log(OKX_timestamp)

    useEffect(() => {
        if (cnt_login > 0) {
            CheckKYC();
        }
    }, [login, location]);

    useEffect(() => {
        if (cnt_login > 0) {
            Favorite();
            Listenkey()
        }
        cnt_login = 1;
    }, [login]);

    // 버전확인
    const CheckVersion = () => {
        const objString = localStorage.getItem('version');
        if (objString) {
            if (objString != version) {
                localStorage.setItem('version', version);
                window.location.reload(true);
            }
        }
        else {
            localStorage.setItem('version', version);
            window.location.reload(true);
        }
    }

    // 즐겨찾기 목록 불러오기
    const Favorite = async () => {
        let objString = localStorage.getItem('token');
        if (objString != null) {
            let obj = JSON.parse(objString)
            let token = obj.value;

            await axios.get(process.env.REACT_APP_API + "/api/v1/account/user/bookmark", {
                headers: { Authorization: `Bearer ${token}` }
            }).then((response) => {
                let tmp = response.data.data
                if (tmp) {
                    tmp.map(function (a, i) {
                        if (a.exchange === "okx") {
                            if (a.type === "spot") dispatch(addCoin_OKX_S_Favorite(a.coin))
                            else dispatch(addCoin_OKX_F_Favorite(a.coin))
                        }
                        else {
                            if (a.type === "spot") dispatch(addCoin_Binance_S_Favorite(a.coin))
                            else dispatch(addCoin_Binance_F_Favorite(a.coin))
                        }
                    })
                }
            }).catch((error) => {
                dispatch(check_Error({ "bol": true, "no": 1, "msg": error }))
            })
        }
    }

    // KYC 확인
    const CheckKYC = async () => {
        let objString = localStorage.getItem('token');
        if (objString != null) {
            let obj = JSON.parse(objString)
            let jwt = obj.value;

            await axios.get(process.env.REACT_APP_API + "/api/v1/account/user/check/kyc", {
                headers: { Authorization: `Bearer ${jwt}` }
            }).then((response) => {
                let tmp = response.data.data
                if (tmp) {
                    dispatch(changeKYC(tmp))
                }
            }).catch((error) => {
                dispatch(check_Error({ "bol": true, "no": 2, "msg": error }))
            })
        }
    }

    //  Bn Listenkey 확인
    const Listenkey = async () => {
        let objString = localStorage.getItem('token');
        if (objString != null) {
            let obj = JSON.parse(objString);
            let token = obj.value;
            await axios.get(process.env.REACT_APP_API + "/api/v1/account/user/get/listenkey", {
                headers: { Authorization: `Bearer ${token}` }
            }).then((response) => {
                let tmp = response.data.data
                if (tmp) {
                    if (tmp.listenKey) {
                        dispatch(change_Binance_ListenKey({ "futures": tmp.listenKey }))
                        setListenkey_futures(tmp.listenKey)
                    }
                    if (tmp.spotListenKey) {
                        dispatch(change_Binance_ListenKey({ "spot": tmp.spotListenKey }))
                        setListenkey_spot(tmp.spotListenKey)
                    }
                }
            }).catch((error) => {
                dispatch(check_Error({ "bol": true, "no": 3, "msg": error }))
            })
        }
    }



    return (
        <div id="api">
            <OKX_Instruments setInstrumentData={setInstrumentData} />
            <OKX_Wallet />
            <Binance_Name />
            <Binance_Wallet_Spot listenkey_spot={listenkey_spot} />
            <Binance_Wallet_Futures listenkey_futures={listenkey_futures} />
            {(loca == "main" || loca == "market" && SelectType == 0 || loca == "futures" && SelectType == 0) ? <OKX_Futures instrumentsData={instrumentsData} /> : ""}
            {(loca == "main" || loca == "market" && SelectType == 1 || loca == "futures" && SelectType == 1) ? <Binance_Futures /> : ""}
            {(loca == "futures" && SelectType == 0) ? <OKX_Position /> : ""}
            {(loca == "futures" && SelectType == 1) ? <Binance_Position listenkey_futures={listenkey_futures} /> : ""}
            {(loca == "market" || loca == "spot" || loca == "wallet") && SelectType == 0 ? <OKX_Spot /> : ""}
            {loca == "main" || ((loca == "market" || loca == "spot" || loca == "wallet") && SelectType == 1) ? <Binance_Spot /> : ""}
        </div>
    )
}

function Binance_Name({ }) {
    let dispatch = useDispatch()
    useEffect(() => {
        BinanceName()
    }, [])

    const BinanceName = async () => {
        // await axios.get('https://api.binance.com/sapi/v1/capital/config/getall', {
        await axios.get(process.env.REACT_APP_API + `/api/v1/market/bn/get/coin-info`, {
        }).then((response) => {
            let tmp = response.data
            if (tmp) {
                bn_name = tmp
            }
        }).catch((error) => {
            // dispatch(check_Error({ "bol": true, "no": 4, "msg": error }))
        })
    }

    return (
        <div id='OKX_Instruments'></div>
    )
}

function OKX_Instruments({ setInstrumentData }) {
    let dispatch = useDispatch()

    useEffect(() => {
        OKXName()
        FuturesInstruments()
    }, [])

    const FuturesInstruments = async () => {
        let arr = []
        await axios.get(process.env.REACT_APP_API + `/api/v1/market/okx/instruments/swap`
        ).then((response) => {
            let tmp = response.data.data
            if (tmp) {
                tmp.map(function (a, i) {
                    if (a.instId.includes('USDT')) {
                        arr.push({ instId: a.instId, ctVal: Number(a.ctVal) })
                    }
                })
                setInstrumentData(arr)
                dispatch(check_OKX_Instruments(arr))
            }
        }).catch((error) => {
            // dispatch(check_Error({ "bol": true, "no": 5, "msg": error }))
        })
    }

    const OKXName = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/v1/market/okx/get/ccy-info`, {
        }).then((response) => {
            let tmp = response.data
            if (tmp) {
                okx_name = tmp
            }
        }).catch((error) => {
            // dispatch(check_Error({ "bol": true, "no": 6, "msg": error }))
        })
    }

    return (
        <div id='OKX_Instruments'></div>
    )
}

function OKX_Spot({ }) {
    let OKX_S_favorite = useSelector((state) => { return state.OKX_S_favorite })

    const [OKXdataSpot, setOKXDataSpot] = useState([]);
    let dispatch = useDispatch()

    const getData = async () => {
        await axios.get(OKX_urlS)
            .then(response => {
                let tmp = response.data.data
                if (tmp) {
                    setOKXDataSpot(tmp)
                }
            }).catch(error => {
                if (error.response && error.response.status === 429) {
                }
                else {
                    // dispatch(check_Error({ "bol": true, "no": 7, "msg": error }))
                }
            });
    }

    useEffect(() => {
        getData()
        const intervalId = setInterval(() => {
            getData()
        }, 1000)
        return () => clearInterval(intervalId);
    }, [])

    useEffect(() => {
        if (OKXdataSpot) {
            let okx_spot_arr = []
            OKXdataSpot.map(function (a, i) {
                if (a.instId.includes('USDT')) {
                    if (a.volCcy24h > 0 || a.last > 0) {
                        let arr = a.instId.split('-')
                        let point = Math.max(findSamllest(a.last), Math.max(findSamllest(a.high24h), findSamllest(a.low24h)))
                        let name = okx_name ? okx_name.filter((item) => item.ccy == arr[0]) : []

                        if (arr[0] != "USDT") {
                            if (OKX_S_favorite && OKX_S_favorite.includes(arr[0])) {
                                okx_spot_arr.push({
                                    symbol: a.instId, ccy: arr[0], name: arr[0] + "/USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: (Number(a.last) - Number(a.open24h)) * 100 / Number(a.open24h),
                                    lastPrice: a.last, volume: Number(a.vol24h), highPrice: a.high24h, lowPrice: a.low24h, priceChange: (Number(a.last) - Number(a.open24h)), check: false, favorite: true, point: point, exch: "OKX"
                                })
                            }
                            else {
                                okx_spot_arr.push({
                                    symbol: a.instId, ccy: arr[0], name: arr[0] + "/USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: (Number(a.last) - Number(a.open24h)) * 100 / Number(a.open24h),
                                    lastPrice: a.last, volume: Number(a.vol24h), highPrice: a.high24h, lowPrice: a.low24h, priceChange: (Number(a.last) - Number(a.open24h)), check: false, favorite: false, point: point, exch: "OKX"
                                })
                            }
                        }
                    }
                }
            })
            dispatch(OKX_addCoinS(okx_spot_arr))
        }
    }, [OKXdataSpot])
    return (
        <div id='OKX_spot_api'></div>
    )
}

function OKX_Futures({ instrumentsData }) {
    let OKX_F_favorite = useSelector((state) => { return state.OKX_F_favorite })

    const [OKXdataFutures, setOKXDataFutures] = useState([]);
    let dispatch = useDispatch()

    const getData = async () => {
        await axios.get(OKX_urlF)
            .then(response => {
                let tmp = response.data.data
                if (tmp) {
                    setOKXDataFutures(tmp)
                }
            }).catch(error => {
                if (error.response && error.response.status === 429) {
                }
                else {
                    // dispatch(check_Error({ "bol": true, "no": 8, "msg": error }))
                }
            });
    }

    useEffect(() => {
        getData()
        const intervalId = setInterval(() => {
            getData()
        }, 1000)
        return () => clearInterval(intervalId);
    }, [])

    useEffect(() => {
        if (OKXdataFutures) {
            let okx_futures_arr = []
            OKXdataFutures.map(function (a, i) {
                if (a.instId.includes('USDT')) {
                    if (a.volCcy24h > 0 || a.last > 0) {
                        let arr = a.instId.split('-')
                        let point = Math.max(findSamllest(a.last), Math.max(findSamllest(a.high24h), findSamllest(a.low24h)))
                        let name = okx_name ? okx_name.filter((item) => item.ccy == arr[0]) : []

                        let ctVal = 1
                        if (instrumentsData) {
                            let inst = instrumentsData.filter((item) => item.instId == a.instId)
                            ctVal = inst && inst[0] ? inst[0].ctVal : 1
                        }

                        if (arr[0] != "USDT") {
                            if (OKX_F_favorite && OKX_F_favorite.includes(arr[0])) {
                                okx_futures_arr.push({
                                    symbol: a.instId, ccy: arr[0], name: arr[0] + "USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: (Number(a.last) - Number(a.open24h)) * 100 / Number(a.open24h),
                                    lastPrice: a.last, volume: Number(a.vol24h) * ctVal, highPrice: a.high24h, lowPrice: a.low24h, priceChange: (Number(a.last) - Number(a.open24h)), check: false, favorite: true, point: point, exch: "OKX"
                                })
                            }
                            else {
                                okx_futures_arr.push({
                                    symbol: a.instId, ccy: arr[0], name: arr[0] + "USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: (Number(a.last) - Number(a.open24h)) * 100 / Number(a.open24h),
                                    lastPrice: a.last, volume: Number(a.vol24h) * ctVal, highPrice: a.high24h, lowPrice: a.low24h, priceChange: (Number(a.last) - Number(a.open24h)), check: false, favorite: false, point: point, exch: "OKX"
                                })
                            }
                        }
                    }
                }
            })
            dispatch(OKX_addCoinF(okx_futures_arr))
        }
    }, [OKXdataFutures, instrumentsData])
    return (
        <div id='OKX_futures_api'></div>
    )
}

function OKX_Position() {
    let login = useSelector((state) => { return state.login.value });
    let dispatch = useDispatch();
    const CryptoJS = require('crypto-js');
    const timestamp = '' + Date.now() / 1000

    // const [timestamp, setTimestamp] = useState("")

    useEffect(() => {
        if (cnt_login > 0) {
            // Timestamp()
        }
    }, [login])

    // OKX 타임스탬프
    // const Timestamp = async () => {
    //     // let local_time = localStorage.getItem("okx_timestamp")
    //     // if (local_time && JSON.parse(local_time).delay >= Date.now()) {
    //     //     setTimestamp(JSON.parse(local_time).delay)
    //     // }
    //     // else {
    //     await axios.get("https://www.okx.com/api/v5/public/time", {
    //     }).then((response) => {
    //         let tmp = response.data.data
    //         if (tmp && tmp[0] && tmp[0].ts) {
    //             // localStorage.removeItem("okx_timestamp")
    //             setTimestamp(String(Number(tmp[0].ts) / 1000))
    //             // let obj = {
    //             //     time: String(Number(tmp[0].ts) / 1000),
    //             //     delay: Date.now() + 20000
    //             // }
    //             // const objString = JSON.stringify(obj);
    //             // localStorage.setItem("okx_timestamp", objString)
    //         }
    //     }).catch((error) => {
    //         dispatch(check_Error({ "bol": true, "no": 9, "msg": error }))
    //     })
    //     // }
    // }

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null && timestamp.length > 0 && cnt_login > 0) {
            const obj = JSON.parse(objString);
            let token = obj.value;
            let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
            let dec = base64.decode(payload);

            let pre_name = []
            let pre_data = []

            const loginMessage = {
                op: "login",
                args: [
                    {
                        apiKey: JSON.parse(dec).apiKey,
                        passphrase: JSON.parse(dec).passphrase,
                        timestamp: timestamp,
                        sign: CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(timestamp + 'GET' + '/users/self/verify', JSON.parse(dec).secretKey))
                    }
                ]
            }
            const subscribeMessage = {
                op: "subscribe",
                args: [
                    {
                        channel: "positions",
                        instType: "SWAP"
                    }, {
                        channel: "balance_and_position",
                    }
                ]
            }
            let socket = JSON.parse(dec).userId === 1 ? new WebSocket(`wss://wspap.okx.com:8443/ws/v5/private?brokerId=9999`) : new WebSocket(`wss://ws.okx.com:8443/ws/v5/private`);
            socket.onopen = function () {
                socket.send(JSON.stringify(loginMessage))
                const intervalId = setInterval(() => {
                    if (socket.readyState === WebSocket.OPEN) {
                        socket.send("ping");
                    }
                }, 25000)

                return () => {
                    clearInterval(intervalId)
                }
            }
            socket.onmessage = function (event) {
                if (event.data != "pong") {
                    let tmp = JSON.parse(event.data);
                    if (tmp.event === "login") {
                        socket.send(JSON.stringify(subscribeMessage))
                    }
                    if (tmp && tmp.arg && tmp.data && tmp.arg.channel == "positions") {
                        let arr = tmp.data

                        if (arr.length === 1) {
                            if (pre_name.includes(arr[0].instId)) {
                                if (arr && arr[0] && arr[0].adl && arr[0].adl.length > 0) {
                                    pre_data = arr
                                    dispatch(change_OKX_position(arr))
                                }
                                else {
                                    if (arr && arr[0]) {
                                        let ab = pre_name.filter((item) => item != arr[0].instId)
                                        let arr1 = pre_data.filter((item) => item.instId != arr[0].instId)
                                        pre_name = ab
                                        pre_data = arr1
                                        dispatch(change_OKX_position(arr1))
                                    }
                                }
                            }
                            else {
                                if (arr && arr[0]) {
                                    pre_name.push(arr[0].instId)
                                    let arr1 = [...pre_data, arr[0]]
                                    dispatch(change_OKX_position(arr1))
                                }
                            }
                        }
                        else {
                            for (let i = 0; i < arr.length; i++) {
                                if (!pre_name.includes(arr[i].instId)) pre_name.push(arr[i].instId)
                            }
                            pre_data = arr
                            dispatch(change_OKX_position(arr))
                        }
                    }
                    else if (tmp && tmp.arg && tmp.data && tmp.arg.channel == "balance_and_position") {
                        let eventType = tmp.data[0].eventType
                        if (eventType == "liquidation") dispatch(change_OKX_liquidation())
                    }
                }
            }
            socket.onclose = function (event) {
                // console.log("okx_postion close")
                // Timestamp()
            };
            socket.error = function (error) {
                window.location.reload()
            }
            return () => {
                socket.close();
            }
        }
    }, [login, timestamp])
    return (
        <div id='OKX_Position'></div>
    )
}

function OKX_Wallet() {
    let login = useSelector((state) => { return state.login.value });
    let dispatch = useDispatch();
    const CryptoJS = require('crypto-js');
    const timestamp = '' + Date.now() / 1000

    // const [timestamp, setTimestamp] = useState("")

    useEffect(() => {
        if (cnt_login > 0) {
            // Timestamp()
        }
    }, [login])

    // OKX 타임스탬프
    // const Timestamp = async () => {
    //     // let local_time = localStorage.getItem("okx_timestamp")
    //     // if (local_time && JSON.parse(local_time).delay >= Date.now()) {
    //     //     setTimestamp(JSON.parse(local_time).delay)
    //     // }
    //     // else {
    //     await axios.get("https://www.okx.com/api/v5/public/time", {
    //     }).then((response) => {
    //         let tmp = response.data.data
    //         if (tmp && tmp[0] && tmp[0].ts) {
    //             // localStorage.removeItem("okx_timestamp")
    //             setTimestamp(String(Number(tmp[0].ts) / 1000))
    //             dispatch(checkOKX_timestamp(String(Number(tmp[0].ts) / 1000)))
    //             // let obj = {
    //             //     time: String(Number(tmp[0].ts) / 1000),
    //             //     delay: Date.now() + 20000
    //             // }
    //             // const objString = JSON.stringify(obj);
    //             // localStorage.setItem("okx_timestamp", objString)
    //         }
    //     }).catch((error) => {
    //         dispatch(check_Error({ "bol": true, "no": 10, "msg": error }))
    //     })
    //     // }
    // }

    useEffect(() => {
        if (cnt_login > 0) {
            const objString = localStorage.getItem('token');
            if (objString != null) {
                const obj = JSON.parse(objString);
                let token = obj.value;

                SpotBalance(token)
                SpotBalanceUSDT(token);
            }
        }
    }, [login])

    const SpotBalanceUSDT = async (token) => {
        await axios.get(process.env.REACT_APP_API + "/api/v1/wallet/okx/balance", {
            params: {
                ccy: "USDT"
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            let tmp = response.data.data
            if (tmp && tmp[0] && tmp[0].details && tmp[0].details[0]) {
                dispatch(change_OKX_wallet_usdt(tmp[0].details))
            }
        }).catch((error) => {
            dispatch(check_Error({ "bol": true, "no": 11, "msg": error }))
        })
    }

    const SpotBalance = async (token) => {
        await axios.get(process.env.REACT_APP_API + "/api/v1/wallet/okx/balance", {
            params: {
                ccy: ""
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            let tmp = response.data.data
            if (tmp && tmp[0] && tmp[0].details) {
                dispatch(change_OKX_wallet(tmp[0].details))
            }
        }).catch((error) => {
            dispatch(check_Error({ "bol": true, "no": 12, "msg": error }))
        })
    }

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null && timestamp.length > 0 && cnt_login > 0) {
            const obj = JSON.parse(objString);
            let token = obj.value;
            let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
            let dec = base64.decode(payload);

            const loginMessage = {
                op: "login",
                args: [
                    {
                        apiKey: JSON.parse(dec).apiKey,
                        passphrase: JSON.parse(dec).passphrase,
                        timestamp: timestamp,
                        sign: CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(timestamp + 'GET' + '/users/self/verify', JSON.parse(dec).secretKey))
                    }
                ]
            }
            const subscribeMessage = {
                op: "subscribe",
                args: [
                    {
                        channel: "account"
                    }
                ]
            }

            let socket = JSON.parse(dec).userId === 1 ? new WebSocket(`wss://wspap.okx.com:8443/ws/v5/private?brokerId=9999`) : new WebSocket(`wss://ws.okx.com:8443/ws/v5/private`);
            socket.onopen = function () {
                socket.send(JSON.stringify(loginMessage))
                const intervalId = setInterval(() => {
                    if (socket.readyState === WebSocket.OPEN) {
                        socket.send("ping");
                    }
                }, 25000)

                return () => {
                    clearInterval(intervalId)
                }
            }

            socket.onmessage = function (event) {
                let nextArr = []
                if (event.data != "pong") {
                    let tmp = JSON.parse(event.data);
                    if (tmp.event === "login") {
                        socket.send(JSON.stringify(subscribeMessage))
                    }
                    if (tmp && tmp.data && tmp.data[0] && tmp.data[0].details && tmp.data[0].details[0]) {
                        let detail = tmp.data[0].details

                        detail.map(function (a, i) {
                            nextArr.push({ symbol: a.ccy, size: a.availBal })
                        })

                        let ArraysEqual = isEqual(preArr, nextArr);
                        if (!ArraysEqual) {
                            dispatch(change_OKX_wallet(detail))
                        }
                        preArr = nextArr

                        let usdt = detail.filter((item) => item.ccy == "USDT")
                        if (usdt && usdt[0] && usdt[0].availBal) {
                            dispatch(change_OKX_wallet_usdt(usdt))
                            // dispatch(change_OKX_wallet_availBal(usdt[0].availBal))
                        }
                    }
                }
            }
            socket.onclose = function (event) {
                if (cnt > 0) {
                    // Timestamp()
                }
                cnt += 1
            };
            socket.error = function (error) {
                window.location.reload()
            }
            return () => {
                socket.close();
            }
        }
    }, [login, timestamp])
    return (
        <div id='OKX_Wallet'></div>
    )
}

function Binance_Wallet_Spot({ listenkey_spot }) {
    let dispatch = useDispatch();

    const [close, setClose] = useState(false)

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null && listenkey_spot && listenkey_spot.length > 0) {
            const obj = JSON.parse(objString);
            let token = obj.value;
            let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
            let dec = base64.decode(payload);

            let socket = dec.userId === 1 ? new WebSocket(`wss://fstream-auth.binance.com/ws/${listenkey_spot}?listenKey=${listenkey_spot}`) : new WebSocket(`wss://stream.binance.com/ws/${listenkey_spot}`);
            let id;

            socket.onmessage = function (event) {
                let tmp = JSON.parse(event.data);
                if (tmp && tmp.e == "outboundAccountPosition") {
                    if (tmp.B && tmp.B.length > 0) {
                        let usdt = tmp.B.filter((item) => item.a == "USDT")
                        dispatch(change_Binance_wallet_spot(usdt))
                    }
                }
            }
            socket.onclose = function (event) {
                setClose(e => !e)
            };
            socket.error = function (error) {
                window.location.reload()
            }
            return () => {
                socket.close();
                clearInterval(id);
            }
        }
    }, [listenkey_spot, close])

    return (
        <div id='Binance_Wallet_spot'></div>
    )
}

let bn_timestamp = 0
function Binance_Wallet_Futures({ listenkey_futures }) {
    const CryptoJS = require('crypto-js');
    let login = useSelector((state) => { return state.login.value });
    let dispatch = useDispatch();

    const [close, setClose] = useState(false)
    const [timestamp, setTimestamp] = useState(0)

    useEffect(() => {
        if (cnt_login > 0) {
            const objString = localStorage.getItem('token');
            if (objString != null) {
                const obj = JSON.parse(objString);
                let token = obj.value;
                let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
                let dec = base64.decode(payload);

                // Bn_timestamp()
                B_FuturesBalanceUSDT(token);
            }
        }
    }, [login])

    // useEffect(() => {
    //     if (cnt_login > 0) {
    //         const objString = localStorage.getItem('token');
    //         if (objString != null) {
    //             const obj = JSON.parse(objString);
    //             let token = obj.value;
    //             let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
    //             let dec = base64.decode(payload);

    //             if (timestamp > 0) {
    //                 B_FuturesBalanceUSDT1(JSON.parse(dec));
    //             }
    //         }
    //     }
    // }, [login, timestamp])

    const B_FuturesBalanceUSDT = async (token) => {
        await axios.get(process.env.REACT_APP_API + '/api/v1/wallet/bn/futures/info', {
            headers: { Authorization: `Bearer ${token}` }
        }).then((response) => {
            let tmp = response.data.data
            if (tmp) {
                if (tmp.length) {
                    for (let i = 0; i < tmp.length; i++) {
                        if (tmp[i].asset == "USDT") {
                            dispatch(change_Binance_wallet_futures([tmp[i]]))
                        }
                    }
                }
            }
        }).catch((error) => {
            dispatch(check_Error({ "bol": true, "no": 13, "msg": error }))
        })
    }

    const Bn_timestamp = async () => {
        await axios.get('https://api.binance.com/api/v3/time'
        ).then((response) => {
            let tmp = response.data
            if (tmp) {
                setTimestamp(tmp.serverTime)
            }
        }).catch((error) => {
            // dispatch(check_Error({ "bol": true, "no": 14, "msg": error }))
        })
    }

    const B_FuturesBalanceUSDT1 = async (dec) => {
        let params = {
        }

        const queryString = Object.keys(params).map((key) => `${key}=${params[key]}`).join("&");
        const signatureMessage1 = `timestamp=${timestamp}`;
        const signatureMessage = `${queryString === "" ? "" : queryString + "&"}timestamp=${timestamp}`;
        const signature = CryptoJS.HmacSHA256(signatureMessage1, dec.bnSecretKey).toString();

        await axios.get('https://fapi.binance.com/fapi/v2/account', {
            params: {
                'timestamp': timestamp,
                'signature': signature,
            },
            headers: {
                "Content-Type": "application/json",
                'X-MBX-APIKEY': dec.bnApiKey,
            }
        }).then((response) => {
            console.log(response.data)
        }).catch((error) => {
            console.log(error)
            dispatch(check_Error({ "bol": true, "no": 15, "msg": error }))
        })
    }

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null && listenkey_futures && listenkey_futures.length > 0) {
            const obj = JSON.parse(objString);
            let token = obj.value;
            let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
            let dec = base64.decode(payload);

            let socket = dec.userId === 1 ? new WebSocket(`wss://fstream-auth.binance.com/ws/${listenkey_futures}?listenKey=${listenkey_futures}`) : new WebSocket(`wss://fstream.binance.com/ws/${listenkey_futures}`);
            let id;

            socket.onopen = () => {
                id = setInterval(() => {
                    socket.send(JSON.stringify({ method: "REQUEST", params: [listenkey_futures + "@ACCOUNT_UPDATE", listenkey_futures + "@balance"], id: 123 }))
                    // socket.send(JSON.stringify({ method: "REQUEST", params: [listenkey_futures + "@balance"], id: 123 }))
                }, 1000)
            }

            socket.onmessage = function (event) {
                let tmp = JSON.parse(event.data);
                if (tmp && tmp.id == 123) {
                    if (tmp.result && tmp.result.length > 0) {
                        if (tmp.result[0].res && tmp.result[0].res.balances) {
                            let usdt = tmp.result[0].res.balances.filter(i => i.asset == "USDT")
                            dispatch(change_Binance_wallet_futures(usdt))
                        }
                    }
                }
                else if (tmp && tmp.e) {
                    if (tmp.e == "ORDER_TRADE_UPDATE") dispatch(change_Binance_openorder_futures(tmp))
                    else if (tmp.e == "ORDER_TRADE_UPDATE" && tmp.o.o == "LIQUIDATION") dispatch(change_Binance_liquidation())
                }
            }
            socket.onclose = function (event) {
                // console.log("Bn futures_Wallet Close")
                setClose(e => !e)
            };
            socket.error = function (error) {
                window.location.reload()
            }
            return () => {
                socket.close();
                clearInterval(id);
            }
        }
    }, [listenkey_futures, close])

    return (
        <div id='Binance_Wallet_futures'></div>
    )
}

function Binance_Position({ listenkey_futures }) {
    let dispatch = useDispatch();

    const [close, setClose] = useState(false)

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null && listenkey_futures && listenkey_futures.length > 0) {
            const obj = JSON.parse(objString);
            let token = obj.value;
            let payload = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
            let dec = base64.decode(payload);

            let socket = dec.userId === 1 ? new WebSocket(`wss://fstream-auth.binance.com/ws/${listenkey_futures}?listenKey=${listenkey_futures}`) : new WebSocket(`wss://fstream.binance.com/ws/${listenkey_futures}`);
            let id;

            socket.onopen = () => {
                id = setInterval(() => {
                    socket.send(JSON.stringify({ method: "REQUEST", params: [listenkey_futures + "@position"], id: 123 }))
                }, 1000)
            }
            socket.onmessage = function (event) {
                let tmp = JSON.parse(event.data);
                if (tmp && tmp.id == 123) {
                    if (tmp.result && tmp.result.length > 0) {
                        if (tmp.result[0].res && tmp.result[0].res.positions) {
                            let arr = tmp.result[0].res.positions.filter(i => Number(i.positionAmt) != 0)
                            dispatch(change_Binance_position(arr))
                        }
                    }
                }
            }
            socket.onclose = function (event) {
                setClose(e => !e)
            };
            socket.error = function (error) {
                window.location.reload()
            }
            return () => {
                socket.close();
                clearInterval(id);
            }
        }
    }, [listenkey_futures, close])

    return (
        <div id='Binance_Position'></div>
    )
}

let exinfo_futures = []
let exinfo_spot = []

function Binance_Spot({ }) {
    let Binance_S_favorite = useSelector((state) => { return state.Binance_S_favorite })

    const [BinancedataSpot, setBinanceDataSpot] = useState([]);

    let dispatch = useDispatch()

    const getData = async () => {
        const resultS = await axios.get(Binance_urlS);
        setBinanceDataSpot(resultS.data)
    }

    useEffect(() => {
        ExchangeInformation_Spot()
        getData()
    }, [])

    const ExchangeInformation_Spot = async () => {
        let arr = []
        await axios.get('https://api.binance.com/api/v3/exchangeInfo'
        ).then((response) => {
            if (response.data.symbols) {
                let tmp = response.data.symbols
                if (tmp) {
                    tmp.map(function (a, i) {
                        if (a.symbol.includes('USDT') && a.status == "TRADING") arr.push(a.symbol)
                    })
                }
            }
        }).catch((error) => {
            // dispatch(check_Error({ "bol": true, "no": 16, "msg": error }))
        })
        exinfo_spot = arr
    }

    useEffect(() => {
        BinancedataSpot.map(function (a, i) {
            if (a.symbol.includes('USDT')) {
                if (a.volume > 0 || a.lastPrice > 0) {
                    let arr = a.symbol.split('USDT')
                    let point = Math.max(findSamllest(a.lastPrice), Math.max(findSamllest(a.highPrice), findSamllest(a.lowPrice)))
                    let name = []
                    // let name = bn_name.filter((item) => item.ccy == arr[0])

                    if (!arr[1] && exinfo_spot.includes(a.symbol)) {
                        if (Binance_S_favorite && Binance_S_favorite.includes(arr[0])) {
                            dispatch(Binance_addCoinS({
                                symbol: a.symbol, ccy: arr[0], name: arr[0] + "/USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: a.priceChangePercent, lastPrice: a.lastPrice, volume: a.volume
                                , highPrice: a.highPrice, lowPrice: a.lowPrice, priceChange: a.priceChange, check: false, favorite: true, point: point, exch: "Binance"
                            }))
                        }
                        else {
                            dispatch(Binance_addCoinS({
                                symbol: a.symbol, ccy: arr[0], name: arr[0] + "/USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: a.priceChangePercent, lastPrice: a.lastPrice, volume: a.volume
                                , highPrice: a.highPrice, lowPrice: a.lowPrice, priceChange: a.priceChange, check: false, favorite: false, point: point, exch: "Binance"
                            }))
                        }
                    }
                }
            }
        })
    }, [BinancedataSpot])

    useEffect(() => {
        let socket = new WebSocket(`wss://stream.binance.com:9443/ws/!ticker@arr`);
        socket.onmessage = function (event) {
            let tmp = JSON.parse(event.data);
            tmp.map(function (a, i) {
                if (a.s.includes('USDT')) {
                    if (a.v > 0 || a.c > 0) {
                        let arr = a.s.split('USDT')
                        if (!arr[1] && exinfo_spot.includes(a.s)) {
                            let point = Math.max(findSamllest(a.c), Math.max(findSamllest(a.h), findSamllest(a.l)))
                            let name = []
                            // let name = bn_name.filter((item) => item.ccy == arr[0])
                            let priceChangePercent = (a.c - a.o) * 100 / a.o

                            if (Binance_S_favorite && Binance_S_favorite.includes(arr[0])) {
                                dispatch(Binance_addCoinS({
                                    symbol: a.s, ccy: arr[0], name: arr[0] + "/USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: priceChangePercent, lastPrice: a.c, volume: a.v,
                                    highPrice: a.h, lowPrice: a.l, priceChange: a.p, check: false, favorite: true, point: point, exch: "Binance"
                                }))
                            }
                            else {
                                dispatch(Binance_addCoinS({
                                    symbol: a.s, ccy: arr[0], name: arr[0] + "/USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: priceChangePercent, lastPrice: a.c, volume: a.v,
                                    highPrice: a.h, lowPrice: a.l, priceChange: a.p, check: false, favorite: false, point: point, exch: "Binance"
                                }))
                            }
                        }
                    }
                }
            })
        }
        return () => {
            socket.close();
        }
    }, [Binance_S_favorite])
    return (
        <div id='Binance_spot_api'></div>
    )
}

function Binance_Futures({ }) {
    let Binance_F_favorite = useSelector((state) => { return state.Binance_F_favorite })

    const [BinancedataFutures, setBinanceDataFutures] = useState([]);
    let dispatch = useDispatch()

    const getData = async () => {
        const resultF = await axios.get(Binance_urlF);
        setBinanceDataFutures(resultF.data)
    }

    useEffect(() => {
        ExchangeInformation_Futures()
        getData()
    }, [])

    const ExchangeInformation_Futures = async () => {
        let arr = []
        await axios.get('https://fapi.binance.com/fapi/v1/exchangeInfo'
        ).then((response) => {
            let tmp = response.data.symbols
            if (tmp) {
                tmp.map(function (a, i) {
                    if (a.symbol.includes('USDT') && a.status == "TRADING") arr.push(a.symbol)
                })
            }
        }).catch((error) => {
            // dispatch(check_Error({ "bol": true, "no": 17, "msg": error }))
        })
        exinfo_futures = arr
    }

    useEffect(() => {
        BinancedataFutures.map(function (a, i) {
            if (a.symbol.includes('USDT')) {
                if (a.volume > 0 || a.lastPrice > 0) {
                    let arr = a.symbol.split('USDT')
                    if (!arr[1] && exinfo_futures.includes(a.symbol)) {
                        let point = Math.max(findSamllest(a.lastPrice), Math.max(findSamllest(a.highPrice), findSamllest(a.lowPrice)))
                        let name = []
                        // let name = bn_name ? bn_name.filter((item) => item.ccy == arr[0]) : []

                        if (Binance_F_favorite && Binance_F_favorite.includes(arr[0])) {
                            dispatch(Binance_addCoinF({
                                symbol: a.symbol, ccy: arr[0], name: arr[0] + "USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: a.priceChangePercent, lastPrice: a.lastPrice, volume: a.volume
                                , highPrice: a.highPrice, lowPrice: a.lowPrice, priceChange: a.priceChange, check: false, favorite: true, point: point, exch: "Binance"
                            }))
                        }
                        else {
                            dispatch(Binance_addCoinF({
                                symbol: a.symbol, ccy: arr[0], name: arr[0] + "USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: a.priceChangePercent, lastPrice: a.lastPrice, volume: a.volume
                                , highPrice: a.highPrice, lowPrice: a.lowPrice, priceChange: a.priceChange, check: false, favorite: false, point: point, exch: "Binance"
                            }))
                        }
                    }
                }
            }
        })
    }, [BinancedataFutures, Binance_F_favorite])

    useEffect(() => {
        let socket = new WebSocket(`wss://fstream.binance.com/ws/!ticker@arr`);
        socket.onmessage = function (event) {
            let tmp = JSON.parse(event.data);
            tmp.map(function (a, i) {
                if (a.s.includes('USDT')) {
                    if (a.v > 0 || a.c > 0) {
                        let arr = a.s.split('USDT')
                        if (!arr[1] && exinfo_futures.includes(a.s)) {
                            let point = Math.max(findSamllest(a.c), Math.max(findSamllest(a.h), findSamllest(a.l)))
                            let name = []
                            // let name = bn_name ? bn_name.filter((item) => item.ccy == arr[0]) : []
                            let priceChangePercent = (a.c - a.o) * 100 / a.o

                            if (Binance_F_favorite && Binance_F_favorite.includes(arr[0])) {
                                dispatch(Binance_addCoinF({
                                    symbol: a.s, ccy: arr[0], name: arr[0] + "USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: priceChangePercent, lastPrice: a.c, volume: a.v,
                                    highPrice: a.h, lowPrice: a.l, priceChange: a.p, check: false, favorite: true, point: point, exch: "Binance"
                                }))
                            }
                            else {
                                dispatch(Binance_addCoinF({
                                    symbol: a.s, ccy: arr[0], name: arr[0] + "USDT", fullName: name && name[0] ? name[0].name : arr[0] + "USDT", priceChangePercent: priceChangePercent, lastPrice: a.c, volume: a.v,
                                    highPrice: a.h, lowPrice: a.l, priceChange: a.p, check: false, favorite: false, point: point, exch: "Binance"
                                }))
                            }
                        }
                    }
                }
            })
        }
        socket.onclose = function (event) {
            console.log("Bn_futures")
        };
        socket.error = function (error) {
            window.location.reload()
        }
        return () => {
            socket.close();
        }
    }, [Binance_F_favorite])
    return (
        <div id='Binance_futures_api'></div>
    )
}

const findSamllest = (n) => {
    if (Number.isInteger(Number(n))) {
        return 0;
    }

    let trimmedStr = String(n).replace(/0+$/, '');

    let cnt = trimmedStr.length
    let cnt1 = trimmedStr.indexOf('.') + 1

    return cnt - cnt1;
}

export default Api;